module.exports = __webpack_public_path__ + "static/media/protectionChannelSubmissionFailed.a72a614a.svg";